/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".not-found[_ngcontent-%COMP%]{margin-top:50px;text-align:center}.not-found[_ngcontent-%COMP%]   h2[_ngcontent-%COMP%]{font-weight:400;margin-bottom:30px}"];
export { styles as styles };
